import { ComponentSummaryId } from 'api/hooks/useGetComponentTree'

export const isModularConnector = (componentSummaryId: ComponentSummaryId) =>
  componentSummaryId.startsWith('modular') ||
  componentSummaryId.startsWith('custom') ||
  componentSummaryId.startsWith('flex')
